module.exports = __webpack_public_path__ + "static/media/Red.0e6f5ff4.png";